import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useStartAddonCreditsView } from "@/hooks/useStartAddonCreditsView";
import LoadingScreen from "@/components/shared/LoadingScreen";

/**
 * Deep-link target for `/credits`.
 *
 * Triggers the add-on credits pane in the chat UI via useStartAddonCreditsView(),
 * which clears the active chat/thread state and navigates to `/`.
 * Primary caller: links rendered in oa-agent messages
 * (e.g. `[Buy add-on credits](/credits)`).
 */
export default function CreditsPage() {
  const { t } = useTranslation();
  const startAddonCreditsView = useStartAddonCreditsView();

  useEffect(() => {
    // `replace: true` so Back from / doesn't bounce the user
    // back to /credits (which would immediately redirect again).
    startAddonCreditsView({ replace: true });
  }, [startAddonCreditsView]);

  return <LoadingScreen title={t("loading")} />;
}
